export enum Capability {
  /** Manages teams billing, users and folders */
  Admin = 'admin',
  /** Manages feeds */
  FeedManager = 'feed-manager',
  /** Owner of the team */
  Owner = 'owner',
}

export function getAllCapabilities(): Capability[] {
  return [Capability.Admin, Capability.FeedManager, Capability.Owner];
}

export function isValidCapability(cap: Capability): boolean {
  return getAllCapabilities().includes(cap);
}

export function isManager(capabilities: Capability[]): boolean {
  return (
    capabilities.includes(Capability.Owner) ||
    capabilities.includes(Capability.Admin) ||
    capabilities.includes(Capability.FeedManager)
  );
}
